import { c as _c } from "react/compiler-runtime";
import { ProfileActivityLogType } from "@/enums";
import ProfileActivityLogsFilterListItem from "./ProfileActivityLogsFilterListItem";
export default function UserPageIdentityActivityLogFilterList(t0) {
  const $ = _c(11);
  const {
    selected,
    options,
    setSelected,
    user
  } = t0;
  let t1;
  if ($[0] !== options || $[1] !== selected || $[2] !== setSelected || $[3] !== user) {
    let t2;
    if ($[5] !== selected || $[6] !== setSelected || $[7] !== user) {
      t2 = itemType => <ProfileActivityLogsFilterListItem key={itemType} itemType={itemType} selectedItems={selected} setSelected={setSelected} user={user} />;
      $[5] = selected;
      $[6] = setSelected;
      $[7] = user;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = options.map(t2);
    $[0] = options;
    $[1] = selected;
    $[2] = setSelected;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="tw-origin-top-right tw-absolute tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5"><ul className="tw-max-h-[calc(20rem+_-10svh)] tw-absolute tw-z-10 tw-pl-1.5 tw-pr-1.5 tw-list-none tw-mt-1 tw-w-full tw-overflow-auto tw-rounded-lg tw-bg-iron-800 tw-py-2 tw-text-base tw-shadow-xl tw-ring-1 tw-ring-inset tw-ring-white/10 focus:tw-outline-none sm:tw-text-sm">{t1}</ul></div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}